import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CouponsActions,
  FetchInAppPurchaseFailAction,
  FetchInAppPurchaseRequestAction,
  FetchInAppPurchaseSuccessAction,
  FetchRmaPaymentFailAction,
  FetchRmaPaymentRequestAction,
  FetchRmaPaymentSuccessAction,
  FetchStripePaymentFailAction,
  FetchStripePaymentRequestAction,
  FetchStripePaymentSuccessAction,
  stateStatusType,
} from "./actionType";
import {  initialState, PaymentState } from "./state";

const fetchRmaPaymentRequest = (
  state: PaymentState,
  action: FetchRmaPaymentRequestAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchRmaPaymentSuccess = (
  state: PaymentState,
  action: FetchRmaPaymentSuccessAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      rmaPaymentResponse: action.payload,
    },
  });
};
const fetchRmaPaymentFail = (
  state: PaymentState,
  action: FetchRmaPaymentFailAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const fetchStripePaymentRequest = (
  state: PaymentState,
  action: FetchStripePaymentRequestAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchStripePaymentSuccess = (
  state: PaymentState,
  action: FetchStripePaymentSuccessAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      stripePaymentResponse: action.payload,
    },
  });
};
const fetchStripePaymentFail = (
  state: PaymentState,
  action: FetchStripePaymentFailAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const fetchInAppPurchasePaymentRequest = (
  state: PaymentState,
  action: FetchInAppPurchaseRequestAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchInAppPurchasePaymentSuccess = (
  state: PaymentState,
  action: FetchInAppPurchaseSuccessAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      inAppPurchaseResponse: action.payload,
    },
  });
};
const fetchInAppPurchasePaymentFail = (
  state: PaymentState,
  action: FetchInAppPurchaseFailAction
) => {
  return updateObject(state, {
    fetchPaymentState: {
      ...state.fetchPaymentState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const fetchPaymentReducer = (state = initialState, action: CouponsActions) => {
  switch (action.type) {
    case actionTypes.FETCH_RMA_PAYMENT_REQUEST:
      return fetchRmaPaymentRequest(state, action);
    case actionTypes.FETCH_RMA_PAYMENT_SUCCESS:
      return fetchRmaPaymentSuccess(state, action);
    case actionTypes.FETCH_RMA_PAYMENT_FAIL:
      return fetchRmaPaymentFail(state, action);
    case actionTypes.FETCH_STRIPE_PAYMENT_REQUEST:
      return fetchStripePaymentRequest(state, action);
    case actionTypes.FETCH_STRIPE_PAYMENT_SUCCESS:
      return fetchStripePaymentSuccess(state, action);
    case actionTypes.FETCH_STRIPE_PAYMENT_FAIL:
      return fetchStripePaymentFail(state, action);
    case actionTypes.FETCH_INAPP_PURCHASE_REQUEST:
      return fetchInAppPurchasePaymentRequest(state, action);
    case actionTypes.FETCH_INAPP_PURCHASE_SUCCESS:
      return fetchInAppPurchasePaymentSuccess(state, action);
    case actionTypes.FETCH_INAPP_PURCHASE_FAIL:
      return fetchInAppPurchasePaymentFail(state, action);
    default:
      return state;
  }
};

export default fetchPaymentReducer;
